
window._ = require('lodash');

/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

try {
    window.$ = window.jQuery = require('jquery');

    require('bootstrap');
} catch (e) {
	//
}

window.moment = require('moment-timezone');

/**
 * Toastr
 */
window.toastr = require('toastr');
window.toastr.options.toastClass = 'toastr';

window.handleError = function(error) {
	if (error.response && error.response.status == 422) {
		var errors = [];

		for (var key in error.response.data.errors) {
			errors = errors.concat(error.response.data.errors[key]);
		}

		toastr.error(errors.join('\n'));
		return error.response.data.errors;
	} else {
		toastr.error(error);
		return [error]
	}
};
